export default "__VITE_ASSET__dTMxNKIL__"